<template>
  <div>Login successful</div>
</template>

<script>
export default {
  name: 'ConsumeAuth',
  mounted() {
    if (this.$route.query && this.$route.query.RelayState) {
      window.location.replace(this.$route.query.RelayState);
    }
  },
};
</script>
